module.exports = "<p>\n  district works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/district/district.component.html
// module id = ./src/app/masters/district/district.component.html
// module chunks = main